export default __webpack_public_path__ + "static/media/banner-m.bd6e6c54.jpg";